import React from 'react';
import { TopbarContainer } from '../../containers';
import { bool } from 'prop-types';
import { propTypes } from '../../util/types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from '../../util/reactIntl';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  Page,
  FieldTextInput,
  FieldCheckbox,
} from '../../components';
import { FeedbackFormVtiger } from '../../forms';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { ensureCurrentUser } from '../../util/data';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { sendFeedback, formatPayload } from '../../util/FeedbackFormAPI';
import flowchart1 from './flowchart1.png';
import flowchart2 from './flowchart2.png';
import css from './ContactPage.module.css';

export const ContactPageComponent = props => {
  const { currentUser, scrollingDisabled, intl } = props;
  const user = ensureCurrentUser(currentUser);

  const userFirstName = user.attributes.profile.firstName;
  const userLastName = user.attributes.profile.lastName;
  const userId = user && user.id && user.id.uuid;
  const userEmail = user.attributes.email;
  const initialValues = {
    name: `${userFirstName} ${userLastName}`,
    email: userEmail,
  };
  const title = intl.formatMessage({ id: 'ContactPage.title' });

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>Contact us</h1>
          <div className={css.contentWrapper}>
            <div className={css.contentSide}>
              <p>
                Signalise is a multi-stakeholder co-operative of Deaf people and communication
                professionals.
              </p>
              <p>
                We've come together to create a community business run by the experts in delivering
                services: the users and providers. <br />
                That's us.
              </p>
            </div>
            <div className={css.contentMain}>
              <section>
                <div className={css.contactContent}>
                  <div>
                    <h2 className={css.contactContentSections}>Our Email Details</h2>
                    <h3>General Enquiries</h3>
                    <a href="mailto:hello@signalise.coop">hello@signalise.coop</a>
                    <h3>Bookings Enquiries</h3>
                    <a href="mailto:bookings@signalise.coop">bookings@signalise.coop</a>
                    <h3>Finance Enquiries</h3>
                    <a href="mailto:finance@signalise.coop">finance@signalise.coop</a>
                    <h3>Feedback</h3>
                    <a href="mailto:feedback@signalise.coop">feedback@signalise.coop</a>
                  </div>
                  <div>
                    <h2 className={css.contactContentSections}>Our Phone Numbers</h2>
                    <p>
                      <span className={css.contactNumbers}>
                        Telephone: <a href="tel:01518080373">0151 808 0373</a>
                      </span>
                      <span className={css.contactNumbers}>
                        SMS: <a href="tel:07723469028">07723 469028</a>
                      </span>
                    </p>
                    <h2 className={css.contactContentSections}>Our Office Address</h2>
                    <p>
                      54 St James Street
                      <br />
                      Liverpool
                      <br />
                      L1 0AB
                      <br />
                    </p>
                  </div>
                </div>
              </section>

              <section className={css.contactForm}>
                <h2>Contact Form</h2>

                <FeedbackFormVtiger
                  userFirstName={userFirstName}
                  userLastName={userLastName}
                  userEmail={userEmail}
                  submitted={props.location.search === '?success=ok'}
                ></FeedbackFormVtiger>
              </section>
              <section className={css.container}>
                <img src={flowchart1} alt="Complaint flowchart 1" className={css.flowchart} />
              </section>
              <section className={css.container}>
                <img src={flowchart2} alt="Complaint flowchart 2" className={css.flowchart} />
              </section>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

ContactPageComponent.defaultProps = {
  currentUser: null,
};

ContactPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const ContactPage = compose(connect(mapStateToProps), injectIntl)(ContactPageComponent);

export default ContactPage;
